var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-info"},[_c('div',{staticClass:"project-info__description",domProps:{"innerHTML":_vm._s(_vm.description)}}),_c('BrochureComponent',{staticClass:"project-info__brochure",attrs:{"value":_vm.brochure}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }